import React from 'react';

interface BozLogoProps {
  size?: number;
  className?: string;
}

export const BozLogo: React.FC<BozLogoProps> = ({ size = 64, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="bozGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{stopColor: '#7C3AED', stopOpacity: 1}} />
          <stop offset="50%" style={{stopColor: '#C026D3', stopOpacity: 1}} />
          <stop offset="100%" style={{stopColor: '#EC4899', stopOpacity: 1}} />
        </linearGradient>
      </defs>
      
      {/* Outer ring */}
      <path 
        d="M32 4C48.5685 4 60 15.4315 60 32C60 48.5685 48.5685 60 32 60C15.4315 60 4 48.5685 4 32C4 15.4315 15.4315 4 32 4Z" 
        fill="url(#bozGradient)" 
        stroke="url(#bozGradient)" 
        strokeWidth="8"
      />
      
      {/* Inner shape (stylized O/target) */}
      <path 
        d="M32 16C38.6274 16 44 21.3726 44 28C44 34.6274 38.6274 40 32 40C25.3726 40 20 34.6274 20 28C20 21.3726 25.3726 16 32 16ZM32 24C35.3137 24 38 26.6863 38 30C38 33.3137 35.3137 36 32 36C28.6863 36 26 33.3137 26 30C26 26.6863 28.6863 24 32 24Z" 
        fill="white"
      />
    </svg>
  );
};
